import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import Select from '../select';
// import Anchor from '../anchor';
import LocaleReceiver from '../locale-provider/LocaleReceiver';

var SelectFilter = {
  mixins: [BaseMixin],
  props: {
    prefixCls: PropTypes.string.def('rc-cascader-filter'),
    showGroup: PropTypes.bool,
    suffixIcon: PropTypes.any,
    fastFinderOption: PropTypes.array,
    fastFinder: PropTypes.oneOf(['letter', 'dropdown']).def('dropdown'),
    fastFinderPos: PropTypes.oneOf(['left', 'top']).def('left'),
    inputProps: PropTypes.object
  },
  data: function data() {
    return {
      currentLetter: undefined
    };
  },

  methods: {
    handleChange: function handleChange(value) {
      this.currentLetter = value;
      this.__emit('change', value);
    },
    createFastFinder: function createFastFinder(option, locale) {
      var _this = this;

      var h = this.$createElement;
      var _$props = this.$props,
          _suffixIcon = _$props.suffixIcon,
          inputProps = _$props.inputProps,
          prefixCls = _$props.prefixCls,
          fastFinder = _$props.fastFinder;

      var options = option ? option.map(function (_ref) {
        var value = _ref.value,
            label = _ref.label;
        return { value: value, label: label };
      }) : [];

      var _ref2 = inputProps || { props: {} },
          shape = _ref2.props.shape;

      if (fastFinder === 'letter') {
        return h(
          'ul',
          { 'class': prefixCls + '-letter' },
          [options.map(function (_ref3) {
            var value = _ref3.value,
                label = _ref3.label;
            return h(
              'li',
              {
                attrs: {
                  title: label
                },
                'class': { active: value === _this.currentLetter },
                on: {
                  'click': function click() {
                    return _this.handleChange(value);
                  }
                }
              },
              [label]
            );
          })]
        );
      } else {
        var selectProps = {
          props: {
            shape: shape,
            placeholder: locale.fastFinder,
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentNode;
            }
          },
          scopedSlots: {
            suffixIcon: function suffixIcon() {
              return _suffixIcon;
            }
          },
          style: { width: '120px' },
          on: {
            change: this.handleChange
          }
        };
        return h(
          Select,
          selectProps,
          [options.map(function (_ref4) {
            var value = _ref4.value,
                label = _ref4.label;
            return h(
              Select.Option,
              { key: value, attrs: { value: value }
              },
              [h(
                'li',
                {
                  attrs: { title: label }
                },
                [label]
              )]
            );
          })]
        );
      }
    },
    renderFilter: function renderFilter(locale) {
      var h = this.$createElement;
      var $props = this.$props,
          $scopedSlots = this.$scopedSlots,
          createFastFinder = this.createFastFinder;
      var prefixCls = $props.prefixCls,
          showGroup = $props.showGroup,
          fastFinderPos = $props.fastFinderPos,
          expandFilter = $props.expandFilter,
          fastFinderOption = $props.fastFinderOption;

      return h(
        'div',
        { 'class': prefixCls },
        [showGroup && fastFinderPos === 'top' && fastFinderOption && fastFinderOption.length > 0 && createFastFinder(fastFinderOption, locale), expandFilter ? h(
          'div',
          { 'class': prefixCls + '-container' },
          [$scopedSlots.filter && $scopedSlots.filter()]
        ) : $scopedSlots.filter && $scopedSlots.filter()]
      );
    }
  },

  render: function render() {
    var h = arguments[0];

    return h(LocaleReceiver, {
      attrs: { componentName: 'Cascader' },
      scopedSlots: { 'default': this.renderFilter } });
  }
};

export default SelectFilter;